package com.macrofocus.eflux.theme

import js.objects.unsafeJso
import mui.material.PaletteMode.Companion.dark
import mui.material.PaletteMode.Companion.light
import mui.material.styles.Theme
import mui.material.styles.createTheme

object Themes {
    val Light = createTheme(
        unsafeJso {
            palette = unsafeJso {
                asDynamic().mode = light

                asDynamic().primary = unsafeJso {
                    // Header background color
//                    main = "#e65100"
                    main = "#1976d2" // Default
                }
                asDynamic().secondary = unsafeJso {
                    main = "#808080"
                }
                asDynamic().background = unsafeJso {
                    paper = "#ffffff"
                    // Content background color
                    default = "#ffffff"
//                    default = "#fafafa"
                }
            }
        }
    ).unsafeCast<Theme>()

    val Dark = createTheme(
        unsafeJso {
            palette = unsafeJso {
                asDynamic().mode = dark

                asDynamic().primary = unsafeJso {
//                    main = "#ffcc80"
                    main = "#90caf9" // Default
                }
                asDynamic().secondary = unsafeJso {
                    main = "#ffffff"
                }
                asDynamic().background = unsafeJso {
                    // General background color
                    paper = "#000000" //"#182f3c" // "#303030"
                    // Content background color
                    default = "#323232" // "#0e2232" For e
                }
            }
        }
    ).unsafeCast<Theme>()
}